export const showToast = (msg) => {
  alert(msg); // temporary simple solution
};
export const showDangerToast = (msg) => {
  alert(msg); // temporary simple solution
};
